import { useAtom } from 'jotai';
import { domain } from 'modules/data';
import { useCallback } from 'react';

import { schedulerRadioCheckedState } from './SchedulerDay.states';

export const useSchedulerRadioChecked = () => {
    const [schedulerRadioChecked, setSchedulerRadioChecked] = useAtom(schedulerRadioCheckedState);

    const handleRadioCheckedChange = useCallback(
        (value: domain.ScheduleDayType) => {
            setSchedulerRadioChecked(value);
        },
        [setSchedulerRadioChecked]
    );

    return {
        schedulerRadioChecked,
        handleRadioCheckedChange,
    };
};
